export default __webpack_public_path__ + "img/agent.167f9d5f.svg";